import { create } from "zustand";
import { Refund, RefundSearchParams } from "../../types";

interface RefundDisputeState {
  refunds: Refund[];
  setRefunds: (refunds: Refund[]) => void;
  loading: boolean;
  refundsLoaded: boolean;
  setRefundsLoaded: (loaded: boolean) => void;
}

const generateRefundsSet = ({refundsLoadedInitial = false} = {}) => (set: any) => ({
  refunds: [],
  loading: true,
  setRefunds: (refunds: Refund[]) => set({ refunds, loading: false }),
  refundsLoaded: refundsLoadedInitial,
  setRefundsLoaded: (refundsLoaded: boolean) => set({ refundsLoaded }),
})

export const useRefunds = create<RefundDisputeState>(generateRefundsSet());


interface RefundsSearchParamsState {
  refundSearchParams: RefundSearchParams | null;
  setRefundSearchParams: (refundSearchParams: RefundSearchParams) => void;
  activePage: number;
  setActivePage: (activePage: number) => void;
}

const refundSearchParamsStateSet = (set: any) => ({
    refundSearchParams: null,
    setRefundSearchParams: (refundSearchParams: RefundSearchParams) => set({ refundSearchParams }),
    activePage: 1,
    setActivePage: (activePage: number) => set({ activePage }),
  });

export const useRefundSearchParams = create<RefundsSearchParamsState>(refundSearchParamsStateSet);